module.exports = __webpack_public_path__ + "img/3I.b48dc0f5.png";